import React from 'react';
import './EmptyState.css';

interface EmptyStateProps {
  icon?: string;
  title?: string;
  description?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon = '📦',
  title = '暂无数据',
  description = '暂时没有内容',
}) => {
  return (
    <div className="empty-state">
      <div className="empty-icon">{icon}</div>
      <div className="empty-text">{title}</div>
      <div className="empty-hint">{description}</div>
    </div>
  );
};

export default EmptyState;
